import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

export default function ManifestoSectionV2() {
  return (
    <section className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="grid gap-14 md:grid-cols-[0.85fr_1.15fr] md:gap-16">
          <div className="md:sticky md:top-24 md:self-start">
            <SectionLabel>Notre manifeste</SectionLabel>
            <h2 className="mt-6 font-marketing-display text-[clamp(32px,4.2vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-charcoal-800">
              Un outil de caisse doit servir ceux qui{' '}
              <span className="underline-lime">vendent</span>.
            </h2>
          </div>

          <div className="border-l-[3px] border-lime-500 bg-paper p-8 shadow-neobrutal-6 md:p-10">
            <div className="absolute -mt-14 ml-2 font-marketing-display text-[80px] font-bold leading-none text-lime-500">
              “
            </div>
            <div className="space-y-5 font-marketing-body text-[17px] leading-[1.65] text-charcoal-700 md:text-[18px]">
              <p>
                Pendant 15 ans, on a regardé les commerçants africains se faire vendre des caisses
                pensées à Paris, à San Francisco, à Berlin. Des outils qui supposent un réseau
                stable, un serveur à côté, une carte bancaire dans chaque poche.
              </p>
              <p>
                Nous, on vit ici. On sait que{' '}
                <em className="bg-paper font-semibold not-italic text-charcoal-900 underline decoration-lime-500 decoration-2 underline-offset-2">
                  le courant tombe
                </em>
                . Que{' '}
                <em className="bg-paper font-semibold not-italic text-charcoal-900 underline decoration-lime-500 decoration-2 underline-offset-2">
                  Orange coupe
                </em>
                . Que Wave ne passe pas partout. Qu'un caissier se trompe, qu'un livreur perd son
                ticket, qu'un stock se dissout en une journée si personne ne compte.
              </p>
              <p>
                Velko est notre réponse : un outil qui marche{' '}
                <em className="bg-paper font-semibold not-italic text-charcoal-900 underline decoration-lime-500 decoration-2 underline-offset-2">
                  sans internet stable
                </em>
                , qui parle{' '}
                <em className="bg-paper font-semibold not-italic text-charcoal-900 underline decoration-lime-500 decoration-2 underline-offset-2">
                  Mobile Money
                </em>{' '}
                comme un natif, qui ne te juge pas si tu débutes avec 12 produits et 2 employés.
              </p>
            </div>

            <div className="mt-8 flex items-center gap-4 border-t-2 border-dashed border-charcoal-300 pt-6">
              <span className="flex h-12 w-12 items-center justify-center border-2 border-charcoal-800 bg-lime-500 font-marketing-display text-lg font-bold text-charcoal-800 shadow-neobrutal-2">
                V
              </span>
              <div>
                <div className="font-marketing-display text-[15px] font-bold text-charcoal-800">
                  L'équipe fondatrice
                </div>
                <div className="font-marketing-mono text-[11px] font-medium uppercase tracking-[0.1em] text-charcoal-500">
                  Velko · Yaoundé, Cameroun
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
